import { Routes } from '@angular/router';
import { LoginComponent } from './core/pages/login/login.component';
import { LogoutComponent } from './core/pages/logout/logout.component';
import { ForgotPasswordComponent } from './core/pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './core/pages/reset-password/reset-password.component';
import { authGuard } from './core/guards/auth.guard';
import { ProcessTokenComponent } from './core/pages/process-token/process-token.component';
import { NotFoundComponent } from './core/pages/not-found/not-found.component';

export const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    canActivate: [authGuard],
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent,
  },
  {
    path: 'process-token',
    component: ProcessTokenComponent,
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
